import React from "react";
import { useStaticQuery, graphql } from "gatsby";

//Brands
import Panasonic from "../../../images/brands/Panasonic.jpg";
import Mitsubishi from "../../../images/brands/Mitsubishi.jpg";
import Haier from "../../../images/brands/Haier.jpg";
import Daikin from "../../../images/brands/Daikin.jpg";

//Heatpumps
import HaierIndoor from "../../../images/heatpumps/Haier Indoor.jpg";
import HaierOutdoor from "../../../images/heatpumps/Haier Outdoor.jpg";
import PanasonicIndoor from "../../../images/heatpumps/Panasonic Indoor.jpg";
import PanasonicIndoor2 from "../../../images/heatpumps/Panasonic Indoor 2.jpg";
import PanasonicOutdoor from "../../../images/heatpumps/Panasonic Outdoor.jpg";

import SlideShow from "../../../components/slider";
import HeroBan from "../../../components/HeroBan";
import Layout from "../../../components/layout";

const Rooms = ({ pageContext }) => {
  const wpdata = useStaticQuery(graphql`
    {
      wp {
        page(id: "residential/heat-pumps/rooms", idType: URI) {
          residentialHeatPumpRooms {
            heroBackgroundColor
            heroContent
            heroHeading
            heroImage {
              altText
              sourceUrl
            }
            heroLink {
              target
              title
              url
            }
            hoItems {
              content
              heading
              image {
                altText
                sourceUrl
              }
            }
            link {
              target
              title
              url
            }
          }
        }
      }
    }
  `);
  const data = wpdata?.wp?.page?.residentialHeatPumpRooms || {};
  return (
    <Layout pageContext={pageContext}>
      <HeroBan
        image={data?.heroImage?.sourceUrl}
        color={data?.heroBackgroundColor}
      >
        <h5>{data?.heroHeading}</h5>
        <p>{data?.heroContent}</p>
        <a href={data?.heroLink?.url} target={data?.heroLink?.target}>
          {data?.heroLink?.title}
        </a>
      </HeroBan>

      <div className="flex flex-wrap justify-between max-w-7xl mx-auto py-20 w-11/12 md:w-4/5 lg:w-full xl:w-full 2xl:w-4/5 overflow-hidden text-black">
        {data?.hoItems?.map((v, i) => (
          <div
            key={i}
            className="my-4 mx-auto max-w-sm w-1/2 overflow-hidden w-full md:w-full lg:w-1/3 xl:w-1/3"
          >
            <img
              className="w-full mx-auto mb-10"
              src={v?.image?.sourceUrl}
              alt={v?.image?.altText}
            />
            <h5 className="text-black text-4xl my-2">{v?.heading}</h5>
            <p className="lg:h-80 text-xl leading-9">{v?.content}</p>
          </div>
        ))}
        <a
          className="bg-tan text-xl text-black uppercase font-anton text-center px-10 py-3 mx-auto  mt-12 lg:mt-0"
          href={data?.link?.url}
          target={data?.link?.target}
        >
          {data?.link?.title}
        </a>
      </div>

      <div className="heat-pumps-logos flex flex-wrap items-center justify-center max-w-7xl my-28 mx-auto">
        <img className="px-2" src={Panasonic} alt="" />
        <img className="px-2" src={Mitsubishi} alt="" />
        <img className="px-2" src={Haier} alt="" />
        <img className="px-2" src={Daikin} alt="" />
      </div>
    </Layout>
  );
};

export default Rooms;
